<script>
    import { createEventDispatcher } from "svelte";
    import { clickAction } from "$/utils/clickAction";

    export let authority;
    export let editable;
    export let showRole;

    const dispatch = createEventDispatcher();

    let showDeleteDialog = false;
</script>

<div class="user-card">
    {#if showDeleteDialog}
        <div class="dialog">
            <span class="dialog-title"> Remove this user? </span>

            <div class="dialog-btns">
                <button
                    class="dialog-btn"
                    on:click={() => (showDeleteDialog = false)}
                >
                    Cancel
                </button>
                <button
                    class="dialog-btn dialog-btn--red"
                    on:click={() => dispatch("delete")}
                >
                    Remove
                </button>
            </div>
        </div>
    {/if}

    <div class="user-info">
        {#if authority?.user?.firstName !== null && authority?.user?.lastName !== null}
            <div class="user-name">
                {authority?.user?.firstName ?? ""}
                {authority?.user?.lastName ?? ""}
            </div>
        {/if}
        <div class="user-email">
            {authority?.user?.username}
        </div>
    </div>

    {#if showRole}
        {#if editable}
            <div
                class="delete-user-icon-wrapper"
                use:clickAction={() => (showDeleteDialog = true)}
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="user-info__delete-icon"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
                    />
                </svg>
            </div>
        {:else}
            <div class="user-authority">
                {#if authority?.authority === "ROLE_OWNER"}
                    Owner
                {:else}
                    User
                {/if}
            </div>
        {/if}
    {/if}
</div>

<style>
    @import "../main.css";

    .user-card {
        @apply relative flex flex-row items-center justify-between overflow-clip rounded-2xl border border-gray-200 bg-white px-4 py-2 !important;
    }
    .user-info {
        @apply flex flex-col text-sm !important;
    }
    .user-email {
        @apply text-xs !important;
    }
    .user-authority {
        @apply ml-auto text-xs italic text-gray-400 !important;
    }
    .user-info__delete-icon {
        @apply reset ml-auto h-5 w-5 bg-white text-right text-xs outline-none hover:cursor-pointer !important;
    }

    .dialog {
        @apply reset absolute bottom-0 left-0 z-20 flex h-full w-full flex-row bg-pink-100 !important;
    }

    .dialog-title {
        @apply reset px-4 pt-4 text-sm !important;
    }

    .dialog-btns {
        @apply ml-auto flex select-none items-center justify-end p-2 !important;
    }

    .dialog-btn {
        @apply reset rounded-sm border-none px-2 py-1 text-xs font-normal text-black no-underline hover:bg-pink-200 focus:outline-none !important;
    }

    .dialog-btn--red {
        @apply font-bold text-pink-500 hover:bg-pink-200 !important;
    }

    .delete-user-icon-wrapper {
        line-height: 0;
    }
</style>
